import Alpine from 'alpinejs'

import { SITE_MODAL } from './SiteModal'

export default ({
  exitWarningTemplateId = null,
  mobileOpen = false,
  searchOpen = false,
  debug = window?.APP?.CONFIG?.DEBUG || false,
}) => {
  return {
    // $dialog - magic property for Alpine Dialog
    debug,
    exitWarningTemplateId,
    mobileOpen,
    searchOpen,
    init() {
      if (this.debug) {
        console.log('[SiteHeader] initialized', {
          exitWarningTemplateId: this.exitWarningTemplateId,
          mobileOpen: this.mobileOpen,
          searchOpen: this.searchOpen,
        })
      }

      this.$watch('mobileOpen', () => {
        if (this.mobileOpen) {
          this.searchOpen = false
        }
      })
    },
    get exitWarningTemplate() {
      if (!this.exitWarningTemplateId) {
        return console.error('[SiteHeader] site warning template ID not set')
      }
      const template = document.getElementById(this.exitWarningTemplateId)

      if (!template) {
        return console.error(`[SiteHeader] no site warning template found for id ${this.exitWarningTemplateId}`)
      }

      return template
    },
    get exitWarningContent() {
      if (!this.exitWarningTemplate) {
        return console.error('[SiteHeader] no site warning template found')
      }
      return this.exitWarningTemplate.content.cloneNode(true)
    },
    showExitWarning(e) {
      const link = e.target.closest('a[data-exit-warning]')

      if (!link) {
        return
      }

      e.preventDefault()
      const targetUrl = link.href
      const modal = Alpine.store(SITE_MODAL)

      if (!targetUrl || !modal || !this.exitWarningTemplate) {
        return
      }

      modal.showCloseButton = false

      modal.setNextAction(() => {
        window.location = targetUrl
      })
      modal.setContent(this.exitWarningContent)

      modal.isDialogOpen = true
    },
  }
}
